import { jsx } from "panel";
import { CardEl } from "apps/boards/src/dashboards-app/card";
import { SpinnerEl } from "common/components/spinner";
export function template() {
  const {
    cards,
    dashboardFailed,
    dashboardLoaded
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".digest-mode", attrs: {
    elref: "digestMode"
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, dashboardFailed ? /* @__PURE__ */ jsx("div", { attrs: {
    elref: "digestFailed"
  } }, "Unexpected load failure") : dashboardLoaded ? /* @__PURE__ */ jsx("div", { sel: ".digest-cards", attrs: {
    elref: "digestCards",
    // expliclty set `.toString()` here so when all is loaded, the final DOM output
    // will be <div data-loading-finished="true">...</div>
    "data-loading-finished": this.state.dashboardLoadingFinished.toString()
  } }, cards.map((card) => {
    const cardOptions = this.helpers.getCardOptions(card);
    return /* @__PURE__ */ jsx(CardEl, { params: cardOptions.params });
  })) : /* @__PURE__ */ jsx("div", { sel: ".reports-loading", attrs: {
    elref: "digestLoading"
  } }, /* @__PURE__ */ jsx(SpinnerEl, null)));
}
